// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"74":"8faf57525236f9d8bb4f","633":"7ce16349c86c1af0494b","940":"cfeeb3b28a5a27e16f10"}[chunkId] + ".css";
};